<template>
    <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
        <b-col class="mb-5">
            <b-col cols="6">
                <PageTitle title="Sugerir produtos" />
            </b-col>
            <b-col cols="">
                <div class="d-flex justify-content-end">
                    <!-- <b-button 
                        class="mr-3" 
                        variant="danger"
                        @click="$refs.videoManual.toggleOpen({ 
                            url: '', 
                            title: 'Selecionar produtos' 
                        })"
                        >
                        <i class="fas fa-play mr-1"></i>
                        Ver video
                    </b-button> -->
                    <a class="btn btn-success" href="https://api.construp.com.br/assets/Sugerir Produtos (1).pdf" target="_blank" download>
                        <i class="fas fa-file-pdf c-white"></i> Baixar Manual
                    </a>
                </div>
            </b-col>
            <label class="label label-default">Nome do produto <p class="text-danger d-inline">*</p></label>
            <input
                class="form-control mb-3"
                v-model="dataProduct.produtos"
                type="text"
                placeholder="Produto"
                required
            >

            <label class="label label-default">Código de barra (Opcional)</label>
            <input
                onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                class="form-control mb-3"
                v-model="dataProduct.codigo_barra"
                placeholder="Código de barras"
                type="number"
            >
            <label class="label label-default">Marca (Opcional)</label>
            <input
                class="form-control"
                v-model="dataProduct.marca_produtos"
                placeholder="Marca"
                type="text"
            >
            <div>
            </div>
            <div class="mt-3">
                <b-button
                    @click="sendProduct()"
                    variant="success"
                    block
                >
                <i class="mr-2 fas fa-paper-plane"></i>
                    Enviar
                </b-button>
            </div>
        </b-col>
        <VideoManual ref="videoManual"/>
    </b-row>
</template>

<script>
import PageTitle from '../../../components/PageTitle.vue';
import { mapState } from 'vuex';
import VideoManual from '@/components/VideoManual.vue';
export default {
components: { PageTitle, VideoManual },

data() {
    return {
        dataProduct: {
            codigo_barra: null,
            marca_produtos: null,
            produtos: null,
            lojista_id: null,
        }
    }
},

computed: {
    ...mapState(['dadosUsuario']),
},

methods: {
notificationPopup(texto, tipo) {
        this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
        });
    },

sendProduct() {
        if(this.dataProduct.produtos == null) {
            this.notificationPopup('Por favor, digite o nome do produto!', 'warning');
            return;
        }
        const self = this;
        this.dataProduct.lojista_id = this.dadosUsuario.id;
        this.$store
        .dispatch('sendProductData', this.dataProduct)
        .then(() => {
            setTimeout(() => {
                self.notificationPopup( 'Obrigado pela sua sugestão!', 'success' )
                this.dataProduct = {};
            }, 1000);
        })
        .catch(() => {
            this.$store.dispatch('endLoader');
            self.notificationPopup(
            'É necessário que você digite o nome do produto!',
            'warning'
    );
        })
    }
    }
}
</script>

<style scoped>

</style>